/* ============================================================================
   sgp-fiche.js : le comportement de la fiche produit Storegen à paliers,
   28/09/2026.

   Ce que ce fichier fait, et rien d'autre :
   · prix sous le titre : celui de la variante choisie, son prix barré et le badge
     calculé sur les deux prix (pctRemise) ;
   · offre (05/10/2026) : des lignes de choix, une par article ; sans remise réelle,
     « Ajouter un autre article » ; avec, des cartes de lot dont la cochée porte une
     ligne par article. Total, prix à la pièce et économie CALCULÉS sur la somme des
     variantes choisies (calculLot), jamais saisis ;
   · ajout au panier en UNE requête (/cart/add.js, forme { items: [...] }), puis
     ouverture du tiroir du thème (window.SGCart) ;
   · galerie au doigt et vignettes ; date d'expédition sans compte à rebours ;
   · barre collante visible dès que le bouton d'achat est sorti de l'écran par le
     haut, même après un SAUT par-dessus (ancre, retour de page) : un écouteur de
     défilement, pas un IntersectionObserver, qui ne voit pas les sauts ;
   · guide des tailles : tableau, calculateur qui propose puis COCHE la taille ;
   · vidéos : adresse posée seulement quand le bloc arrive à l'écran, pause dès
     qu'il en sort, jamais deux lectures ensemble.
   · avis (V2, lot 3) : la piste défile comme la bande de photos ; un texte long
     replié s'ouvre par « Lire la suite », montré seulement s'il est coupé.

   Le fichier peut être chargé par plusieurs sections : il ne s'exécute qu'une fois.
   Les noeuds sont cherchés au moment de s'en servir, jamais retenus à l'analyse
   (leçon du 22/09 : un script posé avant son formulaire le rate en silence).
   ============================================================================ */
(function () {
  "use strict";
  if (window.SgpFiche) return;

  var NBSP = "\u00a0";
  var reduit = false;
  try { reduit = window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) {}

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ── LE formateur de prix, jumeau de snippets/sgp-prix.liquid ──────────────
     En euros : « 1 234,50 € » (espaces insécables), quel que soit le format de la
     boutique. Autre devise : le format de la boutique, lu comme le fait le tiroir. */
  function prix(c, devise, format) {
    c = Math.round(Number(c) || 0);
    if (!devise || devise === "EUR") {
      var e = Math.floor(c / 100), d = String(c % 100);
      if (d.length < 2) d = "0" + d;
      return String(e).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP) + "," + d + NBSP + "\u20ac";
    }
    var f = String(format || "{{amount}}");
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/), cle = m ? m[1] : "amount";
    function fmt(n, p, t, s) {
      var parts = (n / 100).toFixed(p).split(".");
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + t) + (parts[1] ? s + parts[1] : "");
    }
    var v;
    switch (cle) {
      case "amount_no_decimals": v = fmt(c, 0, ",", "."); break;
      case "amount_with_comma_separator": v = fmt(c, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": v = fmt(c, 0, ".", ","); break;
      case "amount_with_space_separator": v = fmt(c, 2, " ", ","); break;
      case "amount_with_apostrophe_separator": v = fmt(c, 2, "'", "."); break;
      default: v = fmt(c, 2, ",", ".");
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  /* ── Le calcul d'un palier, jumeau du Liquid de sections/sgp-fiche.liquid ──
     total = prix × quantité × (100 − remise) / 100, arrondi au centime ;
     unité = total / quantité ; économie = prix × quantité − total.
     La remise n'est jamais inventée : 0 par défaut, et elle doit correspondre à
     une remise automatique réelle de la boutique (réglage du palier). */
  function calculPalier(prixUnitaire, quantite, remise) {
    var p = Math.round(Number(prixUnitaire) || 0);
    var q = Math.max(1, Math.round(Number(quantite) || 1));
    var r = Math.min(100, Math.max(0, Number(remise) || 0));
    var brut = p * q;
    var total = Math.round(brut * (100 - r) / 100);
    return { total: total, unite: Math.round(total / q), economie: brut - total };
  }

  /* Le calcul d'un LOT (05/10/2026) : la SOMME des variantes choisies, ligne par ligne,
     puis la remise. Le calcul d'avant multipliait le prix de la variante du haut par
     la quantité : faux dès qu'un article du lot est une variante plus chère.
     brut = somme des prix ; total = brut × (100 − remise) / 100, arrondi au centime ;
     unité = total / nombre d'articles ; économie = brut − total. */
  function calculLot(prixLignes, remise) {
    var liste = (prixLignes && prixLignes.length) ? prixLignes : [0];
    var brut = 0;
    for (var k = 0; k < liste.length; k++) brut += Math.round(Number(liste[k]) || 0);
    var r = Math.min(100, Math.max(0, Number(remise) || 0));
    var total = Math.round(brut * (100 - r) / 100);
    return { brut: brut, total: total, unite: Math.round(total / liste.length), economie: brut - total };
  }

  /* Le badge du prix barré, jumeau de lib/shopify/badge-remise.ts et du Liquid : arrondi
     VERS LE BAS (jamais une remise plus forte que la vraie), rien sous 1 %. */
  function pctRemise(prixVente, prixBarre) {
    var p = Math.round(Number(prixVente) || 0), b = Math.round(Number(prixBarre) || 0);
    if (!p || !b || b <= p) return 0;
    return Math.floor((b - p) * 100 / b);
  }

  function capitale(t) { t = String(t || ""); return t.charAt(0).toUpperCase() + t.slice(1); }

  function racineShopify() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return typeof r === "string" && r ? r : "/";
  }

  /* ════════════════════════════ LA FICHE ════════════════════════════ */
  function Fiche(racine) {
    this.racine = racine;
    var brut = $("[data-sgp-donnees]", racine);
    this.D = brut ? JSON.parse(brut.textContent) : { options: [], variantes: [], textes: {} };
    this.T = this.D.textes || {};
    this.etat = { mode: "a", aOptions: false, q: 1, remise: 0, lignes: [] };
    this.ligneGuide = 0;
    racine.__sgp = this;
    this.initOffre();
    this.initGalerie();
    this.initExpedition();
    this.initBarre();
    this.initGuide();
  }

  Fiche.prototype.form = function () { return $("[data-sgp-offre]", this.racine); };
  Fiche.prototype.prix = function (c) { return prix(c, this.D.devise, this.D.format); };
  Fiche.prototype.nomQuantite = function (q) { return q + " " + (q > 1 ? this.D.nomPluriel : this.D.nomSingulier); };

  Fiche.prototype.variante = function (options) {
    var vs = this.D.variantes || [];
    if (!vs.length) return null;
    if (!(this.D.options || []).length) return vs[0];
    for (var i = 0; i < vs.length; i++) {
      var ok = true;
      for (var j = 0; j < options.length; j++) if (vs[i].options[j] !== options[j]) { ok = false; break; }
      if (ok) return vs[i];
    }
    return null;
  };

  /* ── Offre (refaite le 05/10/2026) ───────────────────────────────────────────
     Deux modes, posés par la section (data-sgp-mode) :
     · « a », aucun palier avec remise : des LIGNES de choix (une par article, 3 au
       plus, « Ajouter un autre article »), ou un « − 1 + » sans option ;
     · « b », au moins une remise réelle : des cartes de lot ; la carte cochée porte
       une ligne de choix par article du lot.
     L'état tient les choix de CHAQUE ligne ; le DOM se redessine depuis lui. Une
     ligne nouvelle est recopiée du <template> de la section (même texte que le
     Liquid), avec __N__ et __NUM__ remplacés. */
  Fiche.prototype.initOffre = function () {
    var self = this, form = this.form(), etat = this.etat, D = this.D;
    if (!form) return;
    etat.mode = (form.getAttribute("data-sgp-mode") || D.mode) === "b" ? "b" : "a";
    etat.aOptions = (D.options || []).length > 0;
    var coche = $("[data-sgp-lot] input:checked", form);
    if (coche) { etat.q = +coche.value || 1; etat.remise = +coche.getAttribute("data-remise") || 0; }
    var premiere = $('[data-sgp-ligne="0"]', form);
    var base = (D.options || []).map(function (o, i) {
      var c = premiere && $('input[data-sgp-option="' + i + '"]:checked', premiere);
      return c ? c.value : (o.valeurs[0] || "");
    });
    var n = Math.max(1, $$("[data-sgp-lignes] [data-sgp-ligne]", form).length);
    etat.lignes = [];
    for (var k = 0; k < n; k++) etat.lignes.push({ options: base.slice() });
    this.dessinerLignes(false);
    this.maj(-1);

    form.addEventListener("change", function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest("[data-sgp-lot]") && !t.hasAttribute("data-sgp-option")) {
        etat.q = +t.value || 1; etat.remise = +t.getAttribute("data-remise") || 0;
        self.ajusterLignes(etat.q);
        self.dessinerLignes(true); self.maj(-1);
      } else if (t.hasAttribute("data-sgp-option")) {
        var ligne = t.closest("[data-sgp-ligne]");
        var n = ligne ? +ligne.getAttribute("data-sgp-ligne") || 0 : 0;
        var i = +t.getAttribute("data-sgp-option");
        if (!etat.lignes[n]) return;
        etat.lignes[n].options[i] = t.value;
        if (t.closest("[data-sgp-taille]") && ligne) { var cs = $("[data-sgp-conseil]", ligne); if (cs && !t.__sgpCalcul) cs.hidden = true; }
        t.__sgpCalcul = false;
        self.maj(n);
      } else if (t.hasAttribute("data-sgp-saisie-qte")) {
        etat.q = Math.max(1, Math.min(99, Math.round(+t.value) || 1)); t.value = etat.q; self.maj(-1);
      }
    });
    form.addEventListener("click", function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var ajout = t.closest("[data-sgp-ajout-ligne]"), retirer = t.closest("[data-sgp-retirer]"), pas = t.closest("[data-sgp-pas-qte]");
      if (ajout) {
        if (etat.lignes.length >= (D.maxLignes || 3)) return;
        self.ajusterLignes(etat.lignes.length + 1);
        self.dessinerLignes(true); self.maj(-1);
        var neuve = $('[data-sgp-ligne="' + (etat.lignes.length - 1) + '"] input:checked', form);
        if (neuve) { try { neuve.focus({ preventScroll: true }); } catch (x) { neuve.focus(); } }
      } else if (retirer) {
        var l = retirer.closest("[data-sgp-ligne]"), r = l ? +l.getAttribute("data-sgp-ligne") : -1;
        if (r < 1 || etat.lignes.length < 2) return;
        etat.lignes.splice(r, 1);
        self.dessinerLignes(true); self.maj(-1);
        var b = $("[data-sgp-ajout-ligne]", form);
        if (b) b.focus();
      } else if (pas) {
        var champ = $("[data-sgp-saisie-qte]", form);
        etat.q = Math.max(1, Math.min(99, etat.q + (+pas.getAttribute("data-sgp-pas-qte"))));
        if (champ) champ.value = etat.q;
        self.maj(-1);
      }
    });
  };

  /* Le nombre de lignes suit le lot : une ligne ajoutée reprend les choix de la dernière. */
  Fiche.prototype.ajusterLignes = function (q) {
    var l = this.etat.lignes;
    if (!l.length) l.push({ options: (this.D.options || []).map(function (o) { return o.valeurs[0] || ""; }) });
    while (l.length < q) l.push({ options: l[l.length - 1].options.slice() });
    l.length = Math.max(1, q);
  };

  /* Pose les lignes dans le DOM : dans la carte cochée (mode b), ou sous « Votre
     article » (mode a). `refaire` : toutes les lignes sont recopiées du modèle,
     numéros et noms de champs compris ; sinon celles du Liquid sont gardées. */
  Fiche.prototype.dessinerLignes = function (refaire) {
    var form = this.form(), etat = this.etat, D = this.D;
    if (etat.mode === "b") {
      var boite = $("[data-sgp-lignes]", form);
      $$("[data-sgp-lot]", form).forEach(function (lot) {
        var inp = $("input", lot), panneau = $("[data-sgp-panneau]", lot), on = !!(inp && inp.checked);
        lot.classList.toggle("est-coche", on);
        if (!panneau) return;
        panneau.hidden = !on;
        if (on && boite && boite.parentNode !== panneau) panneau.appendChild(boite);
      });
    }
    var conteneur = $("[data-sgp-lignes]", form), modele = $("[data-sgp-modele-ligne]", this.racine);
    var ajout = $("[data-sgp-ajout-ligne]", form);
    if (ajout) ajout.hidden = etat.lignes.length >= (D.maxLignes || 3);
    if (!conteneur || !modele) return;
    var dom = $$("[data-sgp-ligne]", conteneur);
    if (refaire || dom.length !== etat.lignes.length) {
      conteneur.textContent = "";
      var gabarit = modele.innerHTML;
      etat.lignes.forEach(function (_, n) {
        var t = document.createElement("div");
        t.innerHTML = gabarit.replace(/__N__/g, String(n)).replace(/__NUM__/g, String(n + 1));
        while (t.firstElementChild) conteneur.appendChild(t.firstElementChild);
      });
      dom = $$("[data-sgp-ligne]", conteneur);
    }
    var plusieurs = etat.lignes.length > 1;
    dom.forEach(function (el, n) {
      var tete = $("[data-sgp-ligne-tete]", el);
      if (tete) tete.hidden = !plusieurs;
      var ret = $("[data-sgp-retirer]", el);
      if (ret) ret.hidden = !(etat.mode === "a" && n > 0);
      var choix = (etat.lignes[n] || etat.lignes[0]).options;
      $$("input[data-sgp-option]", el).forEach(function (inp) {
        inp.checked = inp.value === choix[+inp.getAttribute("data-sgp-option")];
      });
    });
  };

  /* Les prix des articles d'un lot de `q` : la variante choisie sur chaque ligne (une
     ligne absente reprend la dernière, c'est ce que le lot posera si on le coche). */
  Fiche.prototype.prixPour = function (q) {
    var self = this, etat = this.etat, vs = this.D.variantes || [];
    var repli = (vs[0] || { prix: 0 }).prix, out = [];
    for (var k = 0; k < q; k++) {
      if (!etat.aOptions) { out.push(repli); continue; }
      var l = etat.lignes[k] || etat.lignes[etat.lignes.length - 1];
      var v = l ? self.variante(l.options) : null;
      out.push(v ? v.prix : repli);
    }
    return out;
  };

  /* Combien d'articles partent : les lignes (produit à options), sinon la quantité. */
  Fiche.prototype.nombre = function () {
    var etat = this.etat;
    if (etat.aOptions) return etat.mode === "b" ? etat.q : etat.lignes.length;
    return etat.q;
  };

  /* Les lignes que l'ajout enverra : une par variante, quantités regroupées.
     `manque` : le rang de la première ligne dont la combinaison n'est pas en vente. */
  Fiche.prototype.lignesPanier = function () {
    var self = this, etat = this.etat, parId = {}, ordre = [], manque = -1;
    function poser(v, n) { if (!parId[v.id]) { parId[v.id] = 0; ordre.push(v.id); } parId[v.id] += n; }
    if (etat.aOptions) {
      for (var k = 0; k < this.nombre(); k++) {
        var l = etat.lignes[k] || etat.lignes[etat.lignes.length - 1];
        var v = l ? self.variante(l.options) : null;
        if (!v || !v.dispo) { if (manque < 0) manque = k; continue; }
        poser(v, 1);
      }
    } else {
      var u = this.variante([]);
      if (!u || !u.dispo) manque = 0; else poser(u, Math.max(1, this.nombre()));
    }
    return { manque: manque, items: ordre.map(function (id) { return { id: id, quantity: parId[id] }; }) };
  };

  /* Tout ce qui dépend des choix : prix sous le titre, légendes et ruptures de chaque
     ligne, montants des cartes, bouton, barre. `n` : la ligne qui vient de changer
     (-1 : aucune), pour montrer sa photo. */
  Fiche.prototype.maj = function (n) {
    var self = this, form = this.form(), etat = this.etat, D = this.D, T = this.T;
    if (!form) return;
    var vs = etat.lignes.map(function (l) { return self.variante(l.options); });
    var v0 = vs[0] || (etat.aOptions ? null : this.variante([]));

    // Le prix sous le titre : celui de la première ligne.
    var pv = $("[data-sgp-prix-vente]", this.racine);
    if (pv && v0) {
      pv.textContent = this.prix(v0.prix);
      var barre = +v0.barre || 0, pct = pctRemise(v0.prix, barre);
      var zb = $("[data-sgp-prix-barre]", this.racine), zbv = $("[data-sgp-prix-barre-valeur]", this.racine), zg = $("[data-sgp-prix-badge]", this.racine);
      if (zb) zb.hidden = !(barre > v0.prix);
      if (zbv) zbv.textContent = barre > v0.prix ? this.prix(barre) : "";
      if (zg) { zg.hidden = pct < 1; zg.textContent = "−" + pct + NBSP + "%"; }
    }

    // Chaque ligne : la valeur dans la légende, les valeurs sans variante en vente barrées.
    var conteneur = $("[data-sgp-lignes]", form);
    var dom = conteneur ? $$("[data-sgp-ligne]", conteneur) : [];
    dom.forEach(function (el, k) {
      var l = etat.lignes[k];
      if (!l) return;
      el.classList.toggle("est-invalide", !vs[k] || !vs[k].dispo);
      $$("[data-sgp-choix]", el).forEach(function (grp) {
        var i = +grp.getAttribute("data-sgp-choix"), b = $("[data-sgp-valeur]", grp);
        if (b) b.textContent = l.options[i] || "";
        $$("input[data-sgp-option]", grp).forEach(function (inp) {
          var essai = l.options.slice(); essai[i] = inp.value;
          var w = self.variante(essai), lab = inp.closest("label");
          if (lab) lab.classList.toggle("est-epuise", !w || !w.dispo);
        });
      });
    });

    // Les cartes de lot : chacune calculée sur les variantes qu'elle poserait.
    $$("[data-sgp-lot]", form).forEach(function (lot) {
      var q = +lot.getAttribute("data-q") || 1, r = +lot.getAttribute("data-remise") || 0;
      var c = calculLot(self.prixPour(q), r);
      var zt = $("[data-sgp-lot-total]", lot), zp = $("[data-sgp-lot-plein]", lot), zu = $("[data-sgp-lot-unite]", lot), ze = $("[data-sgp-lot-eco]", lot);
      if (zt) zt.textContent = self.prix(c.total);
      // Le plein barré, le prix à la pièce et l'économie : seulement avec une remise
      // réelle. Même règle que sections/sgp-fiche.liquid.
      if (zp) zp.textContent = c.economie > 0 ? self.prix(c.brut) : "";
      if (zu) zu.textContent = (q > 1 && c.economie > 0) ? self.prix(c.unite) + " " + T.piece : "";
      if (ze) ze.textContent = c.economie > 0 ? T.economisez + " " + self.prix(c.economie) : "";
    });

    var calc = calculLot(this.prixPour(this.nombre()), etat.mode === "b" ? etat.remise : 0);
    var lp = this.lignesPanier();
    var aucune = !(D.variantes || []).some(function (v) { return v.dispo; });
    var ok = lp.manque < 0 && lp.items.length > 0;
    var bouton = $("[data-sgp-ajouter]", form);
    if (bouton) {
      bouton.disabled = !ok;
      bouton.textContent = ok ? (D.bouton + " · " + this.prix(calc.total)) : (aucune ? T.epuise : T.choix_indispo);
    }
    var retour = $("[data-sgp-retour]", form);
    if (retour) {
      if (!ok && !aucune) {
        var plusieurs = this.nombre() > 1 && etat.aOptions;
        retour.textContent = (plusieurs ? capitale(D.nomSingulier) + " " + (lp.manque + 1) + NBSP + ": " : "") + T.indispo;
      } else retour.textContent = "";
    }
    var premier = lp.items[0];
    var champId = $("[data-sgp-id]", form), champQ = $("[data-sgp-qte]", form);
    if (champId && premier) champId.value = premier.id;
    if (champQ && premier) champQ.value = premier.quantity;

    var rq = $("[data-sgp-resume-q]", this.racine), rp = $("[data-sgp-resume-prix]", this.racine), rb = $("[data-sgp-barre-bouton]", this.racine);
    if (rq) rq.textContent = this.nomQuantite(this.nombre());
    if (rp) rp.textContent = this.prix(calc.total);
    if (rb) rb.disabled = !ok;

    // La photo suit la ligne qui vient de changer ; l'adresse, la première ligne.
    if (n >= 0 && vs[n]) {
      if (vs[n].media) this.montrerMedia(vs[n].media);
      if (n === 0) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set("variant", vs[0].id);
          window.history.replaceState(window.history.state, "", u.toString());
        } catch (e) {}
      }
    }
  };

  /* ── Ajout au panier : une requête, toutes les lignes, puis le tiroir ────── */
  Fiche.prototype.ajouter = function () {
    var self = this, form = this.form();
    var bouton = $("[data-sgp-ajouter]", form), retour = $("[data-sgp-retour]", form);
    var lignes = this.lignesPanier();
    // `manque` est le RANG de la ligne fautive (-1 : aucune), plus un booléen : 0 est une ligne.
    if (lignes.manque >= 0 || !lignes.items.length) { if (retour) retour.textContent = this.T.indispo; return; }
    if (bouton) bouton.disabled = true;
    var ctrl = typeof AbortController !== "undefined" ? new AbortController() : null;
    var minuterie = setTimeout(function () { if (ctrl) ctrl.abort(); }, 12000);
    window.fetch(racineShopify() + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: lignes.items }),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, d: d }; });
    }).then(function (res) {
      clearTimeout(minuterie);
      if (bouton) bouton.disabled = false;
      if (!res.ok) {
        var detail = res.d && (res.d.description || res.d.message);
        if (retour) retour.textContent = self.T.erreur + (detail ? " " + detail : "");
        return;
      }
      if (retour) retour.textContent = self.T.ajoute;
      document.dispatchEvent(new CustomEvent("sgp:ajoute", { detail: { items: lignes.items } }));
      if (window.SGCart && typeof window.SGCart.open === "function") window.SGCart.open();
      else window.location.href = racineShopify() + "cart";
    }).catch(function () {
      clearTimeout(minuterie);
      if (bouton) bouton.disabled = false;
      if (retour) retour.textContent = self.T.erreur;
    });
  };

  /* ── Galerie : vignettes et défilement au doigt restent synchronisés ────── */
  Fiche.prototype.initGalerie = function () {
    var piste = $("[data-sgp-piste]", this.racine), vignettes = $$("[data-sgp-vignette]", this.racine);
    if (!piste) return;
    vignettes.forEach(function (b) {
      b.addEventListener("click", function () {
        piste.scrollTo({ left: +b.getAttribute("data-sgp-vignette") * piste.clientWidth, behavior: reduit ? "auto" : "smooth" });
      });
    });
    var liste = $("[data-sgp-vignettes]", this.racine), suivante = $("[data-sgp-suivante]", this.racine);
    var courante = function () { return Math.round(piste.scrollLeft / Math.max(1, piste.clientWidth)); };
    // La vignette active reste visible dans sa rangée, sans jamais faire défiler la page.
    var montrerVignette = function (i) {
      var b = vignettes[i];
      if (!liste || !b) return;
      var li = b.parentNode, g = li.offsetLeft, d = g + li.offsetWidth, reserve = suivante ? 52 : 0;
      if (g < liste.scrollLeft) liste.scrollLeft = g;
      else if (d > liste.scrollLeft + liste.clientWidth - reserve) liste.scrollLeft = d - liste.clientWidth + reserve;
    };
    // La flèche : photo suivante, puis retour à la première après la dernière.
    if (suivante) suivante.addEventListener("click", function () {
      var n = $$("[data-sgp-vue]", piste).length;
      if (n < 2) return;
      piste.scrollTo({ left: ((courante() + 1) % n) * piste.clientWidth, behavior: reduit ? "auto" : "smooth" });
    });
    var attente = 0;
    piste.addEventListener("scroll", function () {
      cancelAnimationFrame(attente);
      attente = requestAnimationFrame(function () {
        var i = courante();
        vignettes.forEach(function (b, j) { b.setAttribute("aria-current", j === i ? "true" : "false"); });
        montrerVignette(i);
      });
    }, { passive: true });
  };

  Fiche.prototype.montrerMedia = function (idMedia) {
    var piste = $("[data-sgp-piste]", this.racine);
    if (!piste) return;
    var vues = $$("[data-sgp-vue]", piste);
    for (var i = 0; i < vues.length; i++) {
      if (+vues[i].getAttribute("data-media") === +idMedia) {
        piste.scrollTo({ left: i * piste.clientWidth, behavior: reduit ? "auto" : "smooth" });
        return;
      }
    }
  };

  /* ── Date d'expédition : heure limite, jours de préparation, jours fermés ── */
  Fiche.prototype.initExpedition = function () {
    var zone = $("[data-sgp-expedition]", this.racine), cible = zone && $("[data-sgp-date]", zone);
    var x = this.D.expedition;
    if (!zone || !cible || !x) return;
    var d = new Date();
    function ferme(j) { var w = j.getDay(); return (w === 6 && !x.samedi) || (w === 0 && !x.dimanche); }
    if (d.getHours() >= (+x.heureLimite || 0)) d.setDate(d.getDate() + 1);
    var garde = 0;
    while (ferme(d) && garde++ < 7) d.setDate(d.getDate() + 1);
    for (var n = 0; n < (+x.joursPreparation || 0); n++) {
      d.setDate(d.getDate() + 1);
      garde = 0;
      while (ferme(d) && garde++ < 7) d.setDate(d.getDate() + 1);
    }
    var langue = (this.D.langue || "fr").indexOf("en") === 0 ? "en-GB" : "fr-FR";
    try { cible.textContent = new Intl.DateTimeFormat(langue, { weekday: "long", day: "numeric", month: "long" }).format(d); }
    catch (e) { cible.textContent = d.toLocaleDateString(); }
    zone.hidden = false;
  };

  /* ── Barre collante ────────────────────────────────────────────────────────
     Pas d'IntersectionObserver : un saut par-dessus le bouton (ancre, défilement
     rapide, retour de page) ne déclenche aucun rappel, la barre restait cachée
     (constaté au rendu le 28/09). Un écouteur passif, une lecture par image.
     ⚠️ Sur Horizon, la FENÊTRE ne défile jamais : html et body sont figés à la
     hauteur de l'écran et c'est `.page-wrapper` qui défile (base.css). Un écouteur
     posé sur window n'entend donc rien, et la barre ne sortait jamais (vu au rendu
     de l'aperçu du 28/09). L'écoute se fait en CAPTURE sur document : elle entend le
     défilement de n'importe quel conteneur, fenêtre comprise. */
  Fiche.prototype.initBarre = function () {
    var racine = this.racine;
    var barre = $("[data-sgp-barre]", racine);
    if (!barre) return;
    if (!document.querySelector(".sgp-espace-barre")) {
      var espace = document.createElement("div");
      espace.className = "sgp-espace-barre";
      espace.setAttribute("aria-hidden", "true");
      (document.querySelector(".page-wrapper") || document.body).appendChild(espace);
    }
    var attente = 0;
    function majBarre() {
      attente = 0;
      var bouton = $("[data-sgp-ajouter]", racine);
      barre.classList.toggle("est-visible", !!bouton && bouton.getBoundingClientRect().bottom < 0);
    }
    function demander() { if (!attente) attente = requestAnimationFrame(majBarre); }
    document.addEventListener("scroll", demander, { passive: true, capture: true });
    window.addEventListener("scroll", demander, { passive: true });
    window.addEventListener("resize", demander);
    window.addEventListener("pageshow", demander);
    majBarre();
  };

  /* ── Guide des tailles et calculateur ───────────────────────────────────── */
  function intervalle(texte) {
    var s = String(texte || "").replace(/,/g, ".").trim();
    var m = s.match(/(\d+(?:\.\d+)?)\s*(?:-|\u2013|\u2014|à|a|to|\/|~)\s*(\d+(?:\.\d+)?)/i);
    if (m) { var a = +m[1], b = +m[2]; return a <= b ? [a, b] : [b, a]; }
    var u = s.match(/^(\d+(?:\.\d+)?)\s*(?:cm)?$/i);
    return u ? [+u[1], +u[1]] : null;
  }
  /* Lit le tableau RENDU : les colonnes chiffrées en cm deviennent des mesures.
     Une colonne n'est retenue que si son titre dit « cm », ou si TOUTES ses cases
     sont des intervalles plausibles pour un corps (20 à 250) : une colonne de
     pointures ou de tailles européennes ne devient jamais un curseur. */
  function lireTableau(table) {
    if (!table || !table.tHead || !table.tBodies.length) return null;
    var entetes = $$("th", table.tHead).map(function (c) { return c.textContent.trim(); });
    var lignes = $$("tr", table.tBodies[0]).map(function (r) { return $$("th,td", r).map(function (c) { return c.textContent.trim(); }); })
      .filter(function (l) { return l.length > 1 && l[0]; });
    if (lignes.length < 2) return null;
    var mesures = [];
    for (var j = 1; j < entetes.length && mesures.length < 2; j++) {
      var titre = entetes[j] || "";
      if (/inch|pouce|\bin\b|"|lbs?\b|kg\b/i.test(titre)) continue;
      var enCm = /\bcm\b/i.test(titre);
      var vals = lignes.map(function (l) { return intervalle(l[j]); });
      if (vals.some(function (x) { return !x; })) continue;
      var plausibles = vals.every(function (x) { return x[0] >= 20 && x[1] <= 250; });
      var intervalles = vals.every(function (x) { return x[1] > x[0]; });
      if (!enCm && !(plausibles && intervalles)) continue;
      var bas = Math.min.apply(null, vals.map(function (x) { return x[0]; }));
      var haut = Math.max.apply(null, vals.map(function (x) { return x[1]; }));
      var milieu = vals[Math.floor((vals.length - 1) / 2)];
      mesures.push({
        j: j,
        nom: titre.replace(/\s*\(\s*cm\s*\)\s*/i, "").replace(/\s*en\s+cm\s*$/i, "").trim() || titre,
        min: Math.floor(bas - 6), max: Math.ceil(haut + 6),
        defaut: Math.round((milieu[0] + milieu[1]) / 2),
        vals: vals
      });
    }
    if (!mesures.length) return null;
    return { tailles: lignes.map(function (l) { return l[0]; }), mesures: mesures };
  }

  Fiche.prototype.initGuide = function () {
    var self = this, racine = this.racine, guide = $("[data-sgp-guide]", racine);
    if (!guide) return;
    /* Un lien par ligne de choix (05/10/2026), y compris les lignes posées plus tard :
       l'écoute est déléguée, et la ligne qui a ouvert le guide est celle dont le
       calculateur cochera la taille. */
    racine.addEventListener("click", function (e) {
      var ouvreur = e.target && e.target.closest ? e.target.closest("[data-sgp-ouvrir-guide]") : null;
      if (!ouvreur) return;
      var ligne = ouvreur.closest("[data-sgp-ligne]");
      self.ligneGuide = ligne ? +ligne.getAttribute("data-sgp-ligne") || 0 : 0;
      if (typeof guide.showModal === "function") guide.showModal(); else guide.setAttribute("open", "");
    });
    var fermer = function () { if (typeof guide.close === "function") guide.close(); else guide.removeAttribute("open"); };
    var bf = $("[data-sgp-fermer-guide]", guide);
    if (bf) bf.addEventListener("click", fermer);
    guide.addEventListener("click", function (e) { if (e.target === guide) fermer(); });

    var table = $("[data-sgp-tableau]", guide), G = lireTableau(table);
    var calcul = $("[data-sgp-calcul]", guide);
    if (!G || !calcul) return;
    var T = this.T, valeurs = {}, zone = $("[data-sgp-mesures]", guide), lignesDom = table ? $$("tbody tr", table) : [];
    G.mesures.forEach(function (m, k) {
      valeurs[k] = m.defaut;
      var id = "sgp-m-" + (racine.getAttribute("data-section") || "x") + "-" + k;
      var bloc = document.createElement("div");
      bloc.className = "sgp-mesure";
      var tete = document.createElement("div"); tete.className = "sgp-mesure__tete";
      var lab = document.createElement("label"); lab.setAttribute("for", id); lab.textContent = m.nom;
      var sortie = document.createElement("output"); sortie.setAttribute("for", id);
      var nb = document.createTextNode(String(m.defaut)); var unite = document.createElement("small"); unite.textContent = "cm";
      sortie.appendChild(nb); sortie.appendChild(unite);
      tete.appendChild(lab); tete.appendChild(sortie);
      var reglage = document.createElement("div"); reglage.className = "sgp-mesure__reglage";
      function pas(sens, libelle, icone) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "sgp-pas"; b.setAttribute("aria-label", m.nom + " : " + libelle);
        b.innerHTML = '<svg class="sgp-icone" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + icone + '"/></svg>';
        b.addEventListener("click", function () { poser(valeurs[k] + sens); });
        return b;
      }
      var curseur = document.createElement("input");
      curseur.type = "range"; curseur.id = id; curseur.min = m.min; curseur.max = m.max; curseur.step = 1; curseur.value = m.defaut;
      function poser(v) {
        v = Math.max(m.min, Math.min(m.max, Math.round(v)));
        valeurs[k] = v; curseur.value = v; nb.nodeValue = String(v);
        curseur.setAttribute("aria-valuetext", v + " " + T.centimetres);
        calculer();
      }
      curseur.addEventListener("input", function () { poser(+curseur.value); });
      reglage.appendChild(pas(-1, T.cm_moins, "M5 12h14"));
      reglage.appendChild(curseur);
      reglage.appendChild(pas(1, T.cm_plus, "M12 5v14M5 12h14"));
      bloc.appendChild(tete); bloc.appendChild(reglage);
      zone.appendChild(bloc);
    });

    /* Règle : pour chaque mesure, la plus petite taille dont le maximum la contient ;
       on garde la plus grande des tailles trouvées (entre deux, la plus grande). */
    function indice(k, v) {
      var vals = G.mesures[k].vals;
      for (var i = 0; i < vals.length; i++) if (v <= vals[i][1]) return i;
      return -1;
    }
    var proposee = "";
    var btn = $("[data-sgp-choisir-taille]", guide), texte = $("[data-sgp-res-texte]", guide), grand = $("[data-sgp-res-taille]", guide);
    function calculer() {
      var idx = G.mesures.map(function (m, k) { return indice(k, valeurs[k]); });
      lignesDom.forEach(function (tr) { tr.classList.remove("est-conseillee"); });
      if (idx.indexOf(-1) >= 0) {
        grand.textContent = "?"; btn.hidden = true; proposee = "";
        texte.textContent = T.hors_tableau;
        return;
      }
      var i = Math.max.apply(null, idx);
      proposee = G.tailles[i];
      grand.textContent = proposee;
      btn.textContent = T.choisir_taille + " " + proposee;
      btn.hidden = !self.radioTaille(proposee);
      if (lignesDom[i]) lignesDom[i].classList.add("est-conseillee");
      var tous = idx.every(function (x) { return x === idx[0]; });
      if (G.mesures.length === 1) texte.textContent = T.correspond_une + " " + proposee + ".";
      else if (tous) texte.textContent = T.correspond_toutes + " " + proposee + ".";
      else texte.textContent = G.mesures.map(function (m, k) { return (k ? T.votre.toLowerCase() : T.votre) + " " + m.nom.toLowerCase() + " " + T.correspond_au + " " + G.tailles[idx[k]]; }).join(", ")
        + ". " + T.plus_grande + " " + proposee + ", " + T.a_l_aise;
    }
    calculer();
    calcul.hidden = false;
    btn.addEventListener("click", function () {
      var r = self.radioTaille(proposee);
      if (!r) return;
      r.checked = true;
      r.__sgpCalcul = true;
      r.dispatchEvent(new Event("change", { bubbles: true }));
      var ligne = r.closest("[data-sgp-ligne]"), cs = ligne && $("[data-sgp-conseil]", ligne);
      if (cs) cs.hidden = false;
      fermer();
      try { r.focus({ preventScroll: false }); } catch (e) { r.focus(); }
    });
  };

  /* Le bouton radio de la taille proposée, sur la ligne qui a ouvert le guide : même
     nom, sinon un nom qui commence pareil. */
  Fiche.prototype.radioTaille = function (nom) {
    if (!nom) return null;
    var ligne = $('[data-sgp-lignes] [data-sgp-ligne="' + (this.ligneGuide || 0) + '"]', this.racine) || $("[data-sgp-ligne]", this.racine) || this.racine;
    var radios = $$("[data-sgp-taille] input[data-sgp-option]", ligne), bas = nom.toLowerCase();
    for (var i = 0; i < radios.length; i++) if (radios[i].value.toLowerCase() === bas) return radios[i];
    for (var j = 0; j < radios.length; j++) if (radios[j].value.toLowerCase().indexOf(bas + " ") === 0) return radios[j];
    return null;
  };

  /* ════════════════ Ce qui vaut pour toute la page ════════════════ */

  /* L'envoi du formulaire d'offre : pris en phase de CAPTURE sur window, donc AVANT
     l'écouteur du tiroir (posé en capture sur document), qui ne sait envoyer qu'une
     variante. Le formulaire se retrouve par la cible, jamais par form.id : un champ
     nommé « id » masque cette propriété (leçon du 23/09). */
  window.addEventListener("submit", function (e) {
    var form = e.target && e.target.closest ? e.target.closest("[data-sgp-offre]") : null;
    if (!form) return;
    var racine = form.closest("[data-sgp-fiche]"), fiche = racine && racine.__sgp;
    if (!fiche) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fiche.ajouter();
  }, true);

  /* Les boutons qui remontent à l'offre : défilement doux, puis le palier coché
     prend le focus. Sans offre sur la page, ils se retirent (un bouton qui ne mène
     nulle part est pire que pas de bouton). */
  document.addEventListener("click", function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href="#sgp-offre"]') : null;
    if (!a) return;
    var offre = document.getElementById("sgp-offre");
    if (!offre) return;
    e.preventDefault();
    offre.scrollIntoView({ behavior: reduit ? "auto" : "smooth", block: "start" });
    setTimeout(function () {
      var c = offre.querySelector("[data-sgp-lot] input:checked") || offre.querySelector("[data-sgp-ajouter]");
      if (c) { try { c.focus({ preventScroll: true }); } catch (x) { c.focus(); } }
    }, reduit ? 0 : 450);
  });
  function retirerLiensSansOffre() {
    if (document.getElementById("sgp-offre")) return;
    $$("[data-sgp-vers-offre]").forEach(function (a) { a.hidden = true; });
  }

  /* ── Vidéos à la demande ──────────────────────────────────────────────── */
  function initVideos() {
    var videos = $$("video[data-sgp-video]");
    if (!videos.length) return;
    function lancer(v) {
      if (!v.getAttribute("src") && v.getAttribute("data-src")) { v.setAttribute("src", v.getAttribute("data-src")); v.load(); }
      videos.forEach(function (autre) { if (autre !== v && !autre.paused) autre.pause(); });
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    videos.forEach(function (v) {
      var bouton = v.parentNode && $("[data-sgp-lecture]", v.parentNode);
      v.addEventListener("play", function () { if (bouton) bouton.hidden = true; });
      v.addEventListener("pause", function () { if (bouton) bouton.hidden = false; });
      v.addEventListener("click", function () { if (v.paused) lancer(v); else v.pause(); });
      if (bouton) bouton.addEventListener("click", function () { v.__sgpVoulue = true; lancer(v); });
    });
    if (!("IntersectionObserver" in window)) return;
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && en.intersectionRatio >= 0.5) { if (!reduit || v.__sgpVoulue) lancer(v); }
        else if (!v.paused) v.pause();
      });
    }, { threshold: [0, 0.5] });
    videos.forEach(function (v) { obs.observe(v); });
  }

  /* ── La bande de photos et vidéos (V2, lot 2) ──────────────────────────────
     Au doigt, elle défile seule. À la souris, une bande horizontale ne défile pas :
     deux flèches, montrées seulement quand la bande dépasse, éteintes aux deux bouts. */
  function initBandes() {
    $$("[data-sgp-bande]").forEach(function (bande) {
      if (bande.__sgp) return;
      bande.__sgp = true;
      var boite = bande.parentNode;
      var prec = $("[data-sgp-bande-prec]", boite), suiv = $("[data-sgp-bande-suiv]", boite);
      if (!prec || !suiv) return;
      function etat() {
        var deborde = bande.scrollWidth > bande.clientWidth + 2;
        prec.hidden = suiv.hidden = !deborde;
        prec.disabled = bande.scrollLeft <= 2;
        suiv.disabled = bande.scrollLeft + bande.clientWidth >= bande.scrollWidth - 2;
      }
      function aller(sens) { bande.scrollBy({ left: sens * Math.round(bande.clientWidth * 0.8), behavior: reduit ? "auto" : "smooth" }); }
      prec.addEventListener("click", function () { aller(-1); });
      suiv.addEventListener("click", function () { aller(1); });
      bande.addEventListener("scroll", etat, { passive: true });
      window.addEventListener("resize", etat);
      $$("img", bande).forEach(function (i) { if (!i.complete) i.addEventListener("load", etat); });
      etat();
    });
  }

  /* ── Les avis (V2, lot 3) ──────────────────────────────────────────────────
     La piste défile par initBandes (mêmes attributs, flèches sous les cartes). Ici, le texte
     long : replié sur huit lignes par la feuille, « Lire la suite » n'apparaît que s'il est
     VRAIMENT coupé, mesuré après le chargement des polices et à chaque changement de largeur. */
  function initAvis() {
    $$("[data-sgp-avis-suite]").forEach(function (bouton) {
      if (bouton.__sgp) return;
      bouton.__sgp = true;
      var carte = bouton.parentNode, texte = carte && $("[data-sgp-avis-texte]", carte);
      if (!texte) return;
      function mesure() {
        if (carte.classList.contains("est-deplie")) return;
        bouton.hidden = !(texte.scrollHeight > texte.clientHeight + 2);
      }
      bouton.addEventListener("click", function () {
        var ouvert = carte.classList.toggle("est-deplie");
        bouton.setAttribute("aria-expanded", ouvert ? "true" : "false");
        bouton.textContent = bouton.getAttribute(ouvert ? "data-reduire" : "data-suite") || bouton.textContent;
        if (!ouvert) mesure();
      });
      window.addEventListener("resize", mesure);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(mesure, function () {});
      mesure();
    });
  }

  function demarrer() {
    $$("[data-sgp-fiche]").forEach(function (r) { if (!r.__sgp) new Fiche(r); });
    retirerLiensSansOffre();
    initVideos();
    initBandes();
    initAvis();
  }

  window.SgpFiche = { prix: prix, calculPalier: calculPalier, calculLot: calculLot, pctRemise: pctRemise, intervalle: intervalle, demarrer: demarrer };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", demarrer);
  else demarrer();

  /* Éditeur de thème : une section rechargée repart de zéro. */
  document.addEventListener("shopify:section:load", function () { demarrer(); });
})();
